var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribeArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 10.5h11.667m0 0L10.5 4.667m5.834 5.833L10.5 16.333",
    stroke: "#fff",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 10.5h11.667m0 0L10.5 4.667m5.834 5.833L10.5 16.333",
    stroke: "url(#subscribe_arrow_svg__paint0_linear_729_2192)",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "subscribe_arrow_svg__paint0_linear_729_2192",
    x1: 10.5,
    y1: 4.667,
    x2: 10.5,
    y2: 16.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB5FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#6394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BCDFE"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNjY2OTkgMTAuNTAwMUgxNi4zMzM3TTE2LjMzMzcgMTAuNTAwMUwxMC41MDAzIDQuNjY2NzVNMTYuMzMzNyAxMC41MDAxTDEwLjUwMDMgMTYuMzMzNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuNjY2OTkgMTAuNTAwMUgxNi4zMzM3TTE2LjMzMzcgMTAuNTAwMUwxMC41MDAzIDQuNjY2NzVNMTYuMzMzNyAxMC41MDAxTDEwLjUwMDMgMTYuMzMzNCIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfNzI5XzIxOTIpIiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzcyOV8yMTkyIiB4MT0iMTAuNTAwMyIgeTE9IjQuNjY2NzUiIHgyPSIxMC41MDAzIiB5Mj0iMTYuMzMzNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjQkI1RkY0Ii8+CjxzdG9wIG9mZnNldD0iMC41MjA4MzMiIHN0b3AtY29sb3I9IiM2Mzk0RkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNUJDREZFIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgSubscribeArrow as ReactComponent };